module.exports = __webpack_public_path__ + "static/media/cryro1.e0dd6f8f.png";